module.exports = __webpack_public_path__ + "img/cat_funnycatsnft.8042da4.png";